import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetSpecificationsParams } from '~/types/receive.types';

type TypeGetSpecificationsMutationParams = {
  ownerCode: string;
  ids: TypeGetSpecificationsParams['ids'];
};

const fetchSpecifications = async ({ ownerCode, ids }: TypeGetSpecificationsMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_SPECIFICATIONS}/${ownerCode}/specifications?ids=${ids}`,
    {
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고요청관리] 검수확인용 거래명세서 다운로드 Mutation Hook
 */
export const useGetSpecificationsMutation = () => {
  return useDownloadMutation(fetchSpecifications);
};
